module.exports = __webpack_public_path__ + "img/knowledge_select.58e2b5a4.svg";